import axios from '../utils/axiosInstance';

export const editEvaAgentAPI = async (id, data) => {
  const response = await axios.put(`ReportConfiguration/${id}`, data);
  return response;
};
